// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { fuseSparknet as _fuseSparknet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the fuseSparknet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 123
 * Chain Name: Fuse Sparknet
 * Default Block Explorer: https://explorer.fusespark.io
 * Default RPC URL: https://rpc.fusespark.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { fuseSparknet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: fuseSparknet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const fuseSparknet = createCommon({
	..._fuseSparknet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
